export default "__VITE_ASSET__Bg$IaHbn__"